<h1 translate>ERROR_PAGE_NOT_FOUND</h1>
<h2 translate>ERROR_PAGE_NOT_FOUND_TITLE</h2>
<p translate>ERROR_PAGE_NOT_FOUND_PARA</p>
<p>
  <a *ngIf="(isInRole$('BO_BILLING_INVOICES_VIEW') | async)" [routerLink]="['']" class="btn brand btn-outline" translate>ERROR_PAGE_RETURN_HOME</a>
  <a *ngIf="!(isInRole$('BO_BILLING_INVOICES_VIEW') | async)" [routerLink]="[ '/','orders','list']" class="btn brand btn-outline" translate>ERROR_PAGE_RETURN_HOME</a>
</p>
